module.exports = __webpack_public_path__ + "static/media/small-profile.0818e8a8.png";